module.exports = __webpack_public_path__ + "static/media/life-park-list-banner-desktop.f47d1ab2.jpg";